import showElementsOnScroll from '../util/showElementsOnScroll';
import toggleHeader from '../util/toggleHeader';
import scrollTo from '../util/scrollTo';

export default {
  init() {
    // ブラウザのUIを考慮したビューポートの高さをcssに受け渡す
    document.documentElement.style.setProperty('--vh-initial', `${window.innerHeight}px`); // 初期値
    const setVH = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`); // 常に更新
    };
    let resizeTimer;
    $(window).resize(() => {
      setVH();
      document.body.classList.add('resizing');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove('resizing');
      }, 200);
    });
    setVH();

    $(document)
      // ハンバーガーメニュー
      .on('click', '#ham, .modalBackground', function () {
        $('#ham').toggleClass('open')
        const gnav_visibility = $('#ham').hasClass('open')
        $('#global_header').css('top', 0).attr('data-sp_menu_visibility', gnav_visibility)
        $('body').toggleClass('noscroll', gnav_visibility)
      })

      // ページ内リンク
      .on('click', 'a[href^=\\#]', function (e) {
        e.preventDefault()
        const id = '#' + $(e.target).closest('a').attr('href').split('#')[1]
        const margin = $(id).attr('data-scroll-margin') || 0
        scrollTo(id, margin, 1200)
      })

    // ヘッダーの表示・非表示
    toggleHeader()

    // 要素がビューポートに入ったら表示
    showElementsOnScroll()
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
